// extracted by mini-css-extract-plugin
module.exports = {"footer":"BenefitsModal_footer__1SLzo","label":"BenefitsModal_label__DEJRr","benefits-container":"BenefitsModal_benefits-container__2pn2M"};